/** Battle-meme generator context (client-built from map + county detail). */

export type MemeFormatId =
  | 'surrender'
  | 'conscription'
  | 'operation'
  | 'mia'
  | 'declaration'
  | 'dispatch';

export type MemeSizeId = 'landscape' | 'portrait';

export const MEME_SIZES: Record<MemeSizeId, { w: number; h: number; label: string }> = {
  landscape: { w: 1200, h: 675, label: '1200×675' },
  portrait: { w: 1080, h: 1350, label: '1080×1350' },
};

export interface MemeTeamRef {
  id: number;
  name: string;
  short: string;
  color: string;
  logoUrl: string | null;
}

export interface MemeContext {
  leagueId: string;
  leagueName: string;
  seasonYear: number | null;
  date: string | null;
  mapUrl: string;
  countyFips: string | null;
  countyName: string | null;
  stateName: string | null;
  /** Focused / claiming side (usually current owner or standings pick). */
  team: MemeTeamRef | null;
  rival: MemeTeamRef | null;
  winner: MemeTeamRef | null;
  loser: MemeTeamRef | null;
  winnerScore: number | null;
  loserScore: number | null;
  conquestDate: string | null;
  countiesFlipped: number | null;
  teamCounties: number | null;
  teamLandShare: number | null;
  teamPopulation: number | null;
  isZeroLand: boolean;
  nextGame: {
    opponentName: string;
    gameDate: string | null;
    venue: string | null;
  } | null;
  operationName: string | null;
  /** Raw map capture used as battle-map backdrop. */
  mapBlob: Blob;
}

export interface MemeFormatDef {
  id: MemeFormatId;
  label: string;
  /** Fire-back counterpart label when roles flip (UI only for now). */
  fireBackLabel?: string;
  available: (ctx: MemeContext) => boolean;
}
